export interface MonthlyPatternData {
  month: string
  year: number
  transaction_count: number
  total_value: number
  avg_price: number
}

export interface QuarterlyPatternData {
  quarter: string
  year: number
  transaction_count: number
  total_value: number
  avg_price: number
}

export interface MonthAggregateData {
  month_name: string // Jan, Feb, Mar, etc.
  avg_count: number
  total_count: number
}

export interface SeasonalPatternsChartLabels {
  monthlyActivity?: string
  monthlyActivitySubtext?: string
  transactionCount?: string
  totalValue?: string
  quarterlyComparison?: string
  quarterlyComparisonSubtext?: string
  transactions?: string
  seasonalPatterns?: string
  seasonalPatternsSubtext?: string
  month?: string
  averageTransactionCount?: string
  noData?: string
}

export const DEFAULT_SEASONAL_PATTERNS_CHART_LABELS: SeasonalPatternsChartLabels =
  {
    monthlyActivity: 'Monthly Transaction Activity',
    monthlyActivitySubtext: 'Volume and value trends by month',
    transactionCount: 'Transaction Count',
    totalValue: 'Total Value',
    quarterlyComparison: 'Quarterly Comparison',
    quarterlyComparisonSubtext: 'Transaction volume by quarter',
    transactions: 'Transactions',
    seasonalPatterns: 'Seasonal Patterns',
    seasonalPatternsSubtext: 'Average activity by month across all years',
    month: 'Month',
    averageTransactionCount: 'Average Transaction Count',
    noData: 'No seasonal pattern data available',
  }

export interface SeasonalPatternsChartProps {
  monthlyPatterns?: MonthlyPatternData[]
  quarterlyPatterns?: QuarterlyPatternData[]
  monthAggregates?: MonthAggregateData[]
  loading?: boolean
  error?: string | null
  height?: number
  labels?: Partial<SeasonalPatternsChartLabels>
}
